import * as Sentry from '@sentry/react';
import { Routes as RouterRoutes } from 'react-router-dom';

/**
 * @returns Sentry-enabled react-router-dom <Routes/> component
 */
const Routes = Sentry.withSentryReactRouterV6Routing(RouterRoutes);

export default Routes;
